import { Button, Form, Input } from "antd";
import { RegisterationText } from "texts/registerationText";
import FormItem from "../_atoms/FormIItem";
import { generalTexts } from "texts/generalTexts";
import { ArrowLeftIconOutline } from "../icons";
import { FormEvent, useEffect, useState } from "react";
import { phoneRegExp } from "utilities/regex";

interface Props {
  nextStepHandler: (value) => void;
  value: any;
}
const RegisterStep1 = ({ nextStepHandler, value }: Props) => {
  const [form] = Form.useForm();

  const [formData, setFormData] = useState({
    vendorName: null,
    name: null,
    nationalCode: null,
    phoneNumber: null,
    technicalAssistantName: null,
    technicalAssistantphone: null,
    contactNumber: null,
  });

  useEffect(() => {
    setFormData({ ...formData, ...value });
  }, []);

  const onFinish = () => {
    nextStepHandler(formData);
  };
  const changeFormDataHandler = (e: FormEvent<HTMLInputElement>) => {
    const { value, name: key } = e.currentTarget;
    setFormData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  };
  return (
    <div className="w-full">
      <h2 className="text-center text-xl font-medium">{RegisterationText?.welcomTitle}</h2>
      <p className="text-center text-sm font-medium pb-8">{RegisterationText?.welcomText}</p>
      <Form initialValues={value} form={form} layout="vertical" onFinish={onFinish} autoComplete="off">
        <FormItem label={RegisterationText?.pharmacyName} name="vendorName" rules={[{ required: true }]}>
          <Input size="small" name="vendorName" className="text-sm rounded-lg !h-10 w-full" value={formData?.vendorName} onChange={changeFormDataHandler} />
        </FormItem>
        <FormItem label={RegisterationText?.pharmacyManagerName} name="name" rules={[{ required: true }]}>
          <Input size="small" name="name" className="text-sm rounded-lg !h-10 w-full" value={formData?.name} onChange={changeFormDataHandler} />
        </FormItem>
        <FormItem
          label={RegisterationText?.pharmacyManagerNationalCode}
          name="nationalCode"
          rules={[
            { required: true },
            {
              validator: async (_, value) => {
                if (value && value.length !== 10) {
                  throw new Error("کد ملی باید برابر با 10 کارکتر باشد");
                }
              },
            },
          ]}
        >
          <Input size="small" maxLength={10} name="nationalCode" className="text-sm rounded-lg !h-10 w-full" value={formData?.nationalCode} onChange={changeFormDataHandler} />
        </FormItem>
        <FormItem
          label={RegisterationText?.pharmacyManagerMobileNumber}
          name="phoneNumber"
          rules={[
            { required: true },
            {
              validator: async (_, value) => {
                if (value && (value.length !== 11 || !phoneRegExp(value))) {
                  throw new Error("فرمت شماره موبایل صحیح نمی باشد");
                }
              },
            },
          ]}
        >
          <Input maxLength={11} size="small" name="phoneNumber" className="text-sm rounded-lg !h-10 w-full" value={formData?.phoneNumber} onChange={changeFormDataHandler} />
        </FormItem>
        <FormItem label={RegisterationText?.pharmacyTechnicalAssistant} name="technicalAssistantName" rules={[{ required: true }]}>
          <Input size="small" name="technicalAssistantName" className="text-sm rounded-lg !h-10 w-full" value={formData?.technicalAssistantName} onChange={changeFormDataHandler} />
        </FormItem>
        <FormItem
          label={RegisterationText?.pharmacyTechnicalAssistantMobileNumber}
          name="technicalAssistantphone"
          rules={[
            { required: true },
            {
              validator: async (_, value) => {
                if (value && (value.length !== 11 || !phoneRegExp(value))) {
                  throw new Error("فرمت شماره موبایل صحیح نمی باشد");
                }
              },
            },
          ]}
        >
          <Input size="small" name="technicalAssistantphone" maxLength={11} className="text-sm rounded-lg !h-10 w-full" value={formData?.technicalAssistantphone} onChange={changeFormDataHandler} />
        </FormItem>
        <FormItem
          label={RegisterationText?.pharmacyPhoneNumber}
          name="contactNumber"
          rules={[
            { required: true },
            {
              validator: async (_, value) => {
                if (value && value.length !== 8) {
                  throw new Error("فرمت شماره تماس صحیح نمی باشد");
                }
              },
            },
          ]}
        >
          <Input size="small" maxLength={8} name="contactNumber" className="text-sm rounded-lg !h-10 w-full" value={formData?.contactNumber} onChange={changeFormDataHandler} />
        </FormItem>
        <Button type="text" className="bg-black flex justify-center items-center gap-x-1 text-white w-full" htmlType="submit" size="large">
          {generalTexts?.confirmAndContinu}
          <ArrowLeftIconOutline width={24} height={24} stroke="white" />
        </Button>
      </Form>
    </div>
  );
};
export default RegisterStep1;
